import React from "react";

import { useParams } from "react-router-dom";

import useGetTaxConsumptionByClient from "@fartherfinance/frontend/api/Investment/hooks/useGetTaxConsumptionByClientId";
import { ClientId } from "@fartherfinance/frontend/api/Types";

import { CAPITAL_GAINS_TAXES_TOOLTIP_TEXT } from "../constants";
import GainsAndLossesV2 from "../DetailTabs/GainsAndLossesV2";
import { thisYear } from "../utils/taxYearOptions";
import useAdvisorRequestAuth from "@src/multiCustodian/hooks/useAdvisorRequestAuth";
import useRequestAuth from "@src/multiCustodian/hooks/useRequestAuth";
import BorderBox from "@src/sharedComponents/BorderBox/BorderBox";
import BorderBoxBody from "@src/sharedComponents/BorderBox/BorderBoxBody";
import BorderBoxHeader from "@src/sharedComponents/BorderBox/BorderBoxHeader";
import TooltipBasic from "@src/sharedComponents/Tooltip/TooltipBasic";
import toUSD from "@src/utils/toUSD";

import styles from "./CapitalGainsTaxes.module.css";

const CapitalGainsTaxesV2: React.FC = () => {
  const { clientId } = useParams<{ clientId: ClientId }>();

  const advisorAuth = useAdvisorRequestAuth();

  const clientAuth = useRequestAuth();

  const auth = advisorAuth || clientAuth;

  // this component is used for when no tax budgets are available
  // therefore, we don't need to pass a tax-budget id
  const { data } = useGetTaxConsumptionByClient(clientId, {}, auth);

  return (
    <BorderBox className={styles.borderBox}>
      <BorderBoxHeader
        className={styles.borderBoxHeader}
        start={
          <div className={styles.container}>
            <div className={styles.topContainer}>
              <div className={styles.flexRow}>
                <div
                  className={styles.text}
                >{`${thisYear} Capital Gains Taxes`}</div>

                <TooltipBasic text={CAPITAL_GAINS_TAXES_TOOLTIP_TEXT} />
              </div>

              <div className={styles.text2}>
                {data?.netYtdTaxBurden === undefined
                  ? "--"
                  : `${toUSD(data.netYtdTaxBurden.toNumber())}`}
              </div>
            </div>

            <div className={styles.progressBar} />
          </div>
        }
      />
      <BorderBoxBody showTopBorder={true}>
        <GainsAndLossesV2 ignoreTaxBudget={true} />
      </BorderBoxBody>
    </BorderBox>
  );
};

export default CapitalGainsTaxesV2;
